module.exports = __webpack_public_path__ + "static/media/delete-user.aa5aee8e.png";